<template>
  <div class="">
    <div class="w-full flex justify-between lg:justify-start lg:gap-12">
      <div class="xl:w-[21rem]">
        <CampaignsStockholmFashionWeekNavDate />
      </div>
      <div class="ml-auto">
        <CampaignsStockholmFashionWeekNavAmount />
      </div>
    </div>
    <hr class="my-4">
    <div class="grid gap-3">
      <CampaignsStockholmFashionWeekNavMeal />
      <CampaignsStockholmFashionWeekNavTime />
    </div>
  </div>
</template>

<script setup>
// 
</script>